import React from 'react';
import { ReactComponent as NotFound } from '../../../../assets/images/svg/404-img.svg';
import OiButton from '../OiButton/OiButton';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
    return (
        <div className="not-found__container">
            <div className="not-found">
                <h2 className="not-found__header">It seems you're lost!</h2>
                <NotFound className="not-found__img" />
                <h3 className="not-found__title u-half-gradient-bg">Spaceship Not Found</h3>
                <p className="not-found__text">
                    It's like you fell out of the previous spaceship, kindly make use of the blue button to go back home
                </p>
                <Link to="/">
                    <OiButton styles="oi-btn oi-btn--primary oi-btn--radius5 | u-font14sb u-pad_1-2">Go Home</OiButton>
                </Link>
            </div>
        </div>
    );
};

export default NotFoundPage;
